import React, { useState } from 'react';
import { Modal, Button, Input } from 'antd';

const CommentModal = ({ isOpen, onClose, imageUrl, width = 400, height = 400, onSubmit }) => {
    const [adminComment, setAdminComment] = useState('');

    const handleCommentChange = (e) => {
        setAdminComment(e.target.value);
    };

    const handleSubmit = () => {
        // Call the onSubmit function passed from the parent with the comment
        if (onSubmit) {
            onSubmit(adminComment);
        }
        // Reset the comment and close the modal
        setAdminComment('');
        onClose();
    };

    return (
        <Modal
            visible={isOpen}
            onCancel={onClose}
            footer={null}
            title="Remarks"
            width={width}
            bodyStyle={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: `${height}px`,
            }}
        >
            
            <Input.TextArea
                rows={4}
                value={adminComment}
                onChange={handleCommentChange}
                placeholder="Enter your remarks here..."
                style={{ marginTop: '16px' }}
            />

            {/* Submit button */}
            <Button
                type="primary"
                style={{ marginTop: '16px', alignSelf: 'flex-end' }}
                onClick={handleSubmit}
                disabled={!adminComment.trim()} // Disable if comment is empty
            >
                Submit
            </Button>
        </Modal>
    );
};

export default CommentModal;
